import React from 'react';
import styles from './LoadingView.module.css';

const LoadingView: React.FC = () => {
  return (
    <div className={styles.LoadingView__loadingSpin}>
      <div className={styles.spinner} />
    </div>
  );
};

export default LoadingView;
